<template>
  <div class="">
    <b-tabs content-class="mt-3">
      <b-tab title="تنظیمات" active>
        <config-inputs :reservation="reservation"/>
      </b-tab>

      <b-tab title="ساعات کاری">
        <hour-config-inputs :reservation="reservation"/>
      </b-tab>

      <b-tab title="روز های تعطیل">
        <hour-off-times :reservation="reservation"/>
      </b-tab>

      <b-tab title="ایتم اضافه">
        <extra-option :reservation="reservation"/>
      </b-tab>

    </b-tabs>
  </div>
</template>

<script>
import ConfigInputs from "../generalComponent/ConfigInputs.vue";
import ExtraOption from "../generalComponent/ExtraOption/ExtraOption.vue";
import HourConfigInputs from "../hour/HourConfigInputs.vue";
import HourOffTimes from "../hour/OffTimes/HourOffTimes.vue";

export default {
  name: "ReservationHour",
  components: {HourOffTimes, HourConfigInputs, ConfigInputs, ExtraOption},
  props: {
    reservation: {}
  },
}
</script>

<style scoped>

</style>